import moment from 'moment'

import { getDataLunar, getRangeTietKhi, getYearLunar } from '../calender'
import { thienCan, diaChi, nguHanhNapAm, dichCung, dichCungCan } from '../tuvi/amduong'
import {
  AM_CHU_DUONG_THU, AM_DUONG_SAI_LECH, AM_LOC, CACH_GOC,
  CAT_TINH, CO_LOAN, CO_THAN, CUNG_LOC_GIO, CUNG_LOC_NGAY,
  DAO_HOA, DIA_VONG, DIEU_KHACH, DUC_QUY_NHAN,
  GIAP_LOC, HOA_CAI, HOC_DUONG, HONG_DIEM, HONG_LOAN,
  HUNG_TINH, HUYET_NHAN, KHOI_CANH_QUY_NHAN, KIEP_SAT,
  KIM_DU, KIM_THAN, KIM_THAN_CAN, KIM_THAN_NGAY_CAN, KIM_THAN_THANG_CHI,
  KINH_DUONG, LOC_THAN, NGUYEN_THAN_NGHICH, NGUYEN_THAN_THUAN,
  NGUYET_DUC_QUY_NHAN, PHUC_TINH_QUY_NHAN, QUA_TU, QUAN_PHU,
  QUOC_AN_QUY_NHAN, TAI_SAT, TAM_KY_QUY_NHAN, TANG_MON,
  THAI_CUC_QUY_NHAN, THAP_AC_DAI_BAI, THIEN_AT_QUY_NHAN,
  THIEN_DUC_QUY_NHAN_CAN, THIEN_DUC_QUY_NHAN_CHI, THIEN_HY,
  THIEN_LA, THIEN_LOC, THIEN_XA, THIEN_Y, TRACH_MA, TU_PHE,
  TU_QUAN, TU_QUY_NHAN, TUONG_TINH, VAN_XUONG_QUY_NHAN, VONG_THAN
} from './thansat'
import { VUONG_TUONG_HUU_TU_THANG } from './vuongtuonghuutu'
import { SAO_CUNG_MENH } from './saoCungMenh'
import { DV_CAN_LO, DV_CAN_TANG_CHI, DV_VONG_TRUONG_SINH, tinhDoVuongTheoKhoangCach } from './dovuong'

export const THIEN_CAN = [null, 'Giáp', 'Ất', 'Bính', 'Đinh', 'Mậu', 'Kỷ', 'Canh', 'Tân', 'Nhâm', 'Quý']
export const DIA_CHI = [null, 'Tý', 'Sửu', 'Dần', 'Mão', 'Thìn', 'Tị', 'Ngọ', 'Mùi', 'Thân', 'Dậu', 'Tuất', 'Hợi']

export const NGU_HANH = [null, 'K', 'M', 'T', 'H', 'O']
export const KHOI_TRUONG_SINH_DUONG = [null, 6, 12, 9, 3, 3] // di thuan
export const KHOI_TRUONG_SINH_AM = [null, 1, 7, 4, 10, 10] // di nghich
export const VONG_TRUONG_SINH = [null, 'T.Sinh', 'M.Dục', 'Q.Đới', 'L.Quan', 'Đ.Vượng', 'Suy', 'Bệnh', 'Tử', 'Mộ', 'Tuyệt', 'Thai', 'Dưỡng']

export const CAN_TANG_CHI = [null, [10], [6, 10, 8], [1, 3, 5], [2], [5, 2, 10], [3, 5, 7], [4, 6], [6, 4, 2], [7, 9, 5], [8], [5, 8, 4], [9, 1]]

export const THAP_THAN_CUNG_DAU = [null, 'Thiên Ấn', 'Tỷ Kiên', 'Thực Thần', 'Thiên Tài', 'Thiên Quan']
export const THAP_THAN_TRAI_DAU = [null, 'Chính Ấn', 'Kiếp Tài', 'Thương Quan', 'Chính Tài', 'Chính Quan']
export const THAP_THAN = ['Thiên Ấn', 'Chính Ấn', 'Tỷ Kiên', 'Kiếp Tài', 'Thực Thần', 'Thương Quan', 'Thiên Tài', 'Chính Tài', 'Thiên Quan', 'Chính Quan']

export const FORMAT_DATE_TIME = 'DD/MM/YYYY'

export const CONVERT_SINH_KHAC_THAP_THAN = {
  0: 2,
  '-1': 5,
  '-2': 4,
  1: 1,
  2: 3
}

// khoi can theo ngu ho don
export const khoiCanNguHoDon = (canNamId) => {
  let khoiCan
  if ([1, 6].includes(canNamId)) {
    khoiCan = 3
  } else if ([2, 7].includes(canNamId)) {
    khoiCan = 5
  } else if ([3, 8].includes(canNamId)) {
    khoiCan = 7
  } else if ([4, 9].includes(canNamId)) {
    khoiCan = 9
  } else if ([5, 10].includes(canNamId)) {
    khoiCan = 1
  }
  return khoiCan
}

// khoi can gio thay can ngay
export const khoiCanGio = (canNgayId) => {
  let khoiCan
  if ([1, 6].includes(canNgayId)) {
    khoiCan = 1
  } else if ([2, 7].includes(canNgayId)) {
    khoiCan = 3
  } else if ([3, 8].includes(canNgayId)) {
    khoiCan = 5
  } else if ([4, 9].includes(canNgayId)) {
    khoiCan = 7
  } else if ([5, 10].includes(canNgayId)) {
    khoiCan = 9
  }
  return khoiCan
}

export const sinhKhac = (hanh1, hanh2) => {
  const matranSinhKhac = [
    [null, null, null, null, null, null],
    [null, 0, -1, 1, -2, 2],
    [null, -2, 0, 2, 1, -1],
    [null, 2, 1, 0, -1, -2],
    [null, -1, 2, -2, 0, 1],
    [null, 1, -2, -1, 2, 0]
  ]
  return matranSinhKhac[hanh1][hanh2]
}

export const tinhTruongSinh = (lenhThang, nguHanhID, amDuong) => {
  let khoiTruongSinh = KHOI_TRUONG_SINH_DUONG[nguHanhID]
  let vitriTruongSinh = lenhThang < khoiTruongSinh ? 12 + lenhThang - khoiTruongSinh : lenhThang - khoiTruongSinh
  if (amDuong < 0) {
    khoiTruongSinh = KHOI_TRUONG_SINH_AM[nguHanhID]
    vitriTruongSinh = lenhThang < khoiTruongSinh ? khoiTruongSinh - lenhThang : 12 + khoiTruongSinh - lenhThang
  }
  if (lenhThang === khoiTruongSinh) {
    vitriTruongSinh = 0
  }
  return VONG_TRUONG_SINH[vitriTruongSinh + 1]
}

export const tinhThapThan = (nguHanhID, nguHanhNhatChu, amDuong) => {
  const sk = sinhKhac(nguHanhID, nguHanhNhatChu)
  const vitriThapThan = CONVERT_SINH_KHAC_THAP_THAN[sk]
  return amDuong > 0 ? THAP_THAN_CUNG_DAU[vitriThapThan] : THAP_THAN_TRAI_DAU[vitriThapThan]
}

export const anThanSat = (tru, canID, chiID, params) => {
  const { gioiTinh, canNgayId, canNamId, chiNamId, canThangId, chiThangId, chiNgayId, canGioId, chiGioId } = params
  if (HONG_DIEM[canNgayId].includes(chiID) || THIEN_AT_QUY_NHAN[canNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(HUNG_TINH.HONG_DIEM)
  }

  if ((TU_QUAN[canNgayId][0] === canID && TU_QUAN[canNgayId][1] === chiID) ||
    (TU_QUAN[canNamId][0] === canID && TU_QUAN[canNamId][1] === chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.TU_QUAN)
  }

  if (
    VAN_XUONG_QUY_NHAN[canNgayId].includes(chiID) ||
    VAN_XUONG_QUY_NHAN[canNamId].includes(chiID)
  ) {
    tru.thanSat.cattinh.push(CAT_TINH.VAN_XUONG_QUY_NHAN)
  }

  if (THIEN_AT_QUY_NHAN[canNgayId].includes(chiID) ||
    THIEN_AT_QUY_NHAN[canNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.THIEN_AT_QUY_NHAN)
  }
  if (THAI_CUC_QUY_NHAN[canNgayId].includes(chiID) ||
    THAI_CUC_QUY_NHAN[canNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.THAI_CUC_QUY_NHAN)
  }
  if (QUOC_AN_QUY_NHAN[canNgayId].includes(chiID) ||
    QUOC_AN_QUY_NHAN[canNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.QUOC_AN_QUY_NHAN)
  }

  if (LOC_THAN[canNgayId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.LOC_THAN)
  }
  if (KINH_DUONG[canNgayId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.KINH_DUONG)
  }
  if (KIM_DU[canNgayId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.KIM_DU)
  }
  if (AM_DUONG_SAI_LECH[canNgayId].includes(chiID) &&
    [3].includes(tru.truID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.AM_DUONG_SAI_LECH)
  }
  if (GIAP_LOC[canNgayId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.GIAP_LOC)
  }
  if (AM_LOC[canNgayId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.AM_LOC)
  }
  if (THIEN_LOC[canNgayId].includes(canID)) {
    tru.thanSat.cattinh.push(CAT_TINH.THIEN_LOC)
  }

  if (TRACH_MA[chiNgayId].includes(chiID) ||
    TRACH_MA[chiNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.TRACH_MA)
  }
  if (HOA_CAI[chiNgayId].includes(chiID) ||
    HOA_CAI[chiNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.HOA_CAI)
  }
  if (TUONG_TINH[chiNgayId].includes(chiID) ||
    TUONG_TINH[chiNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.TUONG_TINH)
  }
  if (DAO_HOA[chiNgayId].includes(chiID) ||
    DAO_HOA[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.DAO_HOA)
  }
  if (THIEN_LA[chiNgayId].includes(chiID) ||
    THIEN_LA[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.THIEN_LA)
  }
  if (DIA_VONG[chiNgayId].includes(chiID) ||
    DIA_VONG[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.DIA_VONG)
  }
  if (KIEP_SAT[chiNgayId].includes(chiID) ||
    KIEP_SAT[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.KIEP_SAT)
  }
  if (VONG_THAN[chiNgayId].includes(chiID) ||
    VONG_THAN[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.VONG_THAN)
  }

  if (THIEN_DUC_QUY_NHAN_CAN[chiThangId].includes(canID) ||
    THIEN_DUC_QUY_NHAN_CHI[chiThangId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.THIEN_DUC_QUY_NHAN)
  }
  if (NGUYET_DUC_QUY_NHAN[chiThangId].includes(canID)) {
    tru.thanSat.cattinh.push(CAT_TINH.NGUYET_DUC_QUY_NHAN)
  }
  if (DUC_QUY_NHAN[chiThangId].includes(canID)) {
    tru.thanSat.cattinh.push(CAT_TINH.DUC_QUY_NHAN)
  }
  if (TU_QUY_NHAN[chiThangId].includes(canID)) {
    tru.thanSat.cattinh.push(CAT_TINH.TU_QUY_NHAN)
  }
  if (THIEN_Y[chiThangId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.THIEN_Y)
  }
  if (AM_CHU_DUONG_THU[chiThangId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.AM_CHU_DUONG_THU)
  }

  if (CO_THAN[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.CO_THAN)
  }
  if (QUA_TU[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.QUA_TU)
  }
  if (TAI_SAT[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.TAI_SAT)
  }
  if (HONG_LOAN[chiNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.HONG_LOAN)
  }
  if (THIEN_HY[chiNamId].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.THIEN_HY)
  }
  if (TANG_MON[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.TANG_MON)
  }
  if (DIEU_KHACH[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.DIEU_KHACH)
  }
  if (HUYET_NHAN[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.HUYET_NHAN)
  }
  if (QUAN_PHU[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.QUAN_PHU)
  }
  if (CACH_GOC[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.CACH_GOC)
  }

  TAM_KY_QUY_NHAN.forEach((item) => {
    if (((item[0] === canNamId && item[1] === canThangId && item[2] === canNgayId) ||
      (item[0] === canThangId && item[1] === canNgayId && item[2] === canGioId) ||
      (item[0] === canNgayId && item[1] === canThangId && item[2] === canNamId)) &&
      [canNamId, canThangId, canNgayId, canGioId].includes(canID)
    ) {
      tru.thanSat.cattinh.push(CAT_TINH.TAM_KY_QUY_NHAN)
    }
  })
  if ((PHUC_TINH_QUY_NHAN[canNgayId].includes(chiID) ||
    PHUC_TINH_QUY_NHAN[canNamId].includes(chiID))
  // && [3, 1].includes(tru.truID)
  ) {
    tru.thanSat.cattinh.push(CAT_TINH.PHUC_TINH_QUY_NHAN)
  }
  if (KHOI_CANH_QUY_NHAN[canID].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.KHOI_CANH_QUY_NHAN)
  }

  // ngu hanh nap am cua tru nam, ngay
  const napAmNam = nguHanhNapAm(chiNamId, canNamId)
  const napAmNgay = nguHanhNapAm(chiNgayId, canNgayId)
  if (HOC_DUONG[NGU_HANH.indexOf(napAmNam)].includes(chiID) ||
    HOC_DUONG[NGU_HANH.indexOf(napAmNgay)].includes(chiID)) {
    tru.thanSat.cattinh.push(CAT_TINH.HOC_DUONG)
  }
  if (
    (KIM_THAN_THANG_CHI.includes(chiThangId) || KIM_THAN_CAN.includes(canID)) &&
    (KIM_THAN[canNgayId].includes(chiNgayId) ||
      (KIM_THAN[canGioId].includes(chiGioId) && KIM_THAN_NGAY_CAN.includes(canNgayId))
    )) {
    tru.thanSat.cattinh.push(CAT_TINH.KIM_THAN)
  }

  CUNG_LOC_NGAY.forEach((item, index) => {
    if (
      item[0] === canNgayId && item[1] === chiNgayId &&
      CUNG_LOC_GIO[index][0] === canGioId && CUNG_LOC_GIO[index][1] === chiGioId &&
      [3, 4].includes(tru.truID)
    ) {
      tru.thanSat.cattinh.push(CAT_TINH.CUNG_LOC_NGAY)
    }
  })

  if (THIEN_XA[chiThangId][0] === canID && THIEN_XA[chiThangId][1] === chiID) {
    tru.thanSat.cattinh.push(CAT_TINH.THIEN_XA)
  }

  // CAU / GIAO
  let chiNamTang3 = (chiNamId + 3) % 12
  chiNamTang3 = chiNamTang3 > 0 ? chiNamTang3 : 12
  let chiNamGiam3 = (chiNamId - 3) % 12
  chiNamGiam3 = chiNamGiam3 > 0 ? chiNamGiam3 : 12
  if ((gioiTinh && chiNamId % 2 === 1) || (!gioiTinh && chiNamId % 2 === 0)) {
    if (chiID === chiNamTang3) {
      tru.thanSat.hungtinh.push(HUNG_TINH.CAU)
    }
    if (chiID === chiNamGiam3) {
      tru.thanSat.hungtinh.push(HUNG_TINH.GIAO)
    }
  } else {
    if (chiID === chiNamTang3) {
      tru.thanSat.hungtinh.push(HUNG_TINH.GIAO)
    }
    if (chiID === chiNamGiam3) {
      tru.thanSat.hungtinh.push(HUNG_TINH.CAU)
    }
  }

  if ((gioiTinh && chiNamId % 2 === 1) || (!gioiTinh && chiNamId % 2 === 0)) {
    if (NGUYEN_THAN_THUAN[chiNamId].includes(chiID)) {
      tru.thanSat.hungtinh.push(HUNG_TINH.NGUYEN_THAN)
    }
  } else if (NGUYEN_THAN_NGHICH[chiNamId].includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.NGUYEN_THAN)
  }

  if (THAP_AC_DAI_BAI[canID].includes(chiID) && tru.truID === 3) {
    tru.thanSat.hungtinh.push(HUNG_TINH.THAP_AC_DAI_BAI)
  }

  if (TU_PHE[chiThangId][0] === canID && TU_PHE[chiThangId][0] === chiID && tru.truID === 3) {
    tru.thanSat.hungtinh.push(HUNG_TINH.TU_PHE)
  }

  // KHONG_VONG
  const ketThucTuan = dichCung(chiNgayId, 10 - canNgayId)
  const viTriTuan1 = dichCung(ketThucTuan, 1)
  const viTriTuan2 = dichCung(viTriTuan1, 1)
  const tuan = [viTriTuan1, viTriTuan2]
  if (tuan.includes(chiID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.KHONG_VONG)
  }

  if (CO_LOAN[canID].includes(chiID) && [3, 4].includes(tru.truID)) {
    tru.thanSat.hungtinh.push(HUNG_TINH.CO_LOAN)
  }

  return tru
}

export const tinhDvTheoThapThan = (dvObj, tru) => {
  const newObj = { ...dvObj }
  const thapThanCanlo = tru.khuCan.thapThan
  const dvCanlo = tru.khuCan.dovuong ?? 0
  if (!newObj[thapThanCanlo]) {
    newObj[thapThanCanlo] = dvCanlo
  } else {
    newObj[thapThanCanlo] += parseInt(dvCanlo)
  }

  tru.khuChi.canTangChi.forEach((cantang) => {
    const thapThanCantang = cantang.thapThan
    const dvCantang = cantang.dovuong ?? 0
    if (!newObj[thapThanCantang]) {
      newObj[thapThanCantang] = dvCantang
    } else {
      newObj[thapThanCantang] += dvCantang
    }
  })

  return newObj
}

export const tinhDvTheoTruongSinh = (originDv, truongSinh, isCanlo = true) => {
  const viTriTruongSinh = VONG_TRUONG_SINH.findIndex((ts) => ts === truongSinh)
  const dvTheoTruongSinh = DV_VONG_TRUONG_SINH[viTriTruongSinh]
  if (isCanlo) {
    return dvTheoTruongSinh
  }
  return getRoundDecimal(dvTheoTruongSinh * originDv / DV_CAN_LO)
}

export class KhuCan {
  constructor (canID) {
    this.canID = canID
    this.thienCan = thienCan[canID]
    this.dovuong = DV_CAN_LO
  }

  anThapThan (thapThan) {
    this.thapThan = thapThan
    return this
  }

  anTruongSinh (truongSinh) {
    this.truongSinh = truongSinh
    this.dovuong = tinhDvTheoTruongSinh(truongSinh, this.truongSinh)
    return this
  }

  anTruongSinhDong (truongSinhDong) {
    this.truongSinhDong = truongSinhDong
    this.dovuong = tinhDvTheoTruongSinh(truongSinhDong, this.truongSinh)
    return this
  }

  setNhatChu () {
    this.isNhatChu = true
    return this
  }

  anDoVuong (dovuong) {
    this.dovuong = dovuong
    return this
  }
}

export class KhuChi {
  constructor (chiID) {
    this.chiID = chiID
    this.diaChi = diaChi[chiID]
    this.canTangChi = CAN_TANG_CHI[chiID].map(function (canID, canIndex) {
      return {
        ...thienCan[canID],
        dovuong: DV_CAN_TANG_CHI[chiID][canIndex]
      }
    })
  }

  anTruongSinhThapThan (canTangChi) {
    this.canTangChi = canTangChi.map((can) => {
      const originDv = can.dovuong
      const dovuong = tinhDvTheoTruongSinh(originDv, can.truongSinhDong ?? can.truongSinh, false)

      return {
        ...can,
        dovuong
      }
    })
    return this
  }

  setLenhThang () {
    this.setLenhThang = true
    return this
  }

  anDoVuong (dovuong, canTangIndex) {
    this.canTangChi = this.canTangChi.map((can, index) => {
      if (canTangIndex === index) {
        return {
          ...can,
          dovuong
        }
      } else {
        return { ...can }
      }
    })
    return this
  }
}

export class TuTru {
  constructor (truID) {
    this.truID = truID
  }

  anTru (ten, can, chi) {
    return anStructureTru(this, can, chi, ten)
  }

  anDataTru (obj, params) {
    return anDataTru(obj, params)
  }
}

export class DaiVan {
  constructor (daivanId) {
    this.daivanId = daivanId
  }

  anDaivan (can, chi) {
    return anStructureTru(this, can, chi)
  }

  anDataTru (obj, params) {
    return anDataTru(obj, params)
  }

  anMinMax (min, max, year, ngayVaoDaiVan) {
    this.min = min
    this.max = max
    this.year = year
    this.ngayVaoDaiVan = ngayVaoDaiVan
    return this
  }
}

export class TieuVan {
  constructor (tieuVanId, nameTieuVan, tuoi) {
    this.tieuVanId = tieuVanId
    this.year = nameTieuVan
    this.tuoi = tuoi
  }

  anTieuvan (can, chi) {
    return anStructureTru(this, can, chi)
  }

  anDataTru (obj, params) {
    return anDataTru(obj, params)
  }

  anNgayVaoLuunien (value) {
    this.ngayVaoLuunien = value
    return this
  }
}

export class Thang {
  constructor (thangId) {
    this.thangId = thangId
    // this.dayInMonth
  }

  anThang (can, chi) {
    return anStructureTru(this, can, chi)
  }

  anDataTru (obj, params) {
    return anDataTru(obj, params)
  }

  anDayOfMonth (value) {
    this.dayOfMonth = value
    return this
  }

  anNgayVaoLuunienThang (value) {
    this.ngayVaoLuunienThang = value
    return this
  }
}

export class Ngay {
  constructor (ngayId, ngayVaoLuunienNgay) {
    this.ngayId = ngayId
    this.ngayVaoLuunienNgay = ngayVaoLuunienNgay
  }

  anNgay (can, chi) {
    return anStructureTru(this, can, chi)
  }

  anDataTru (obj, params) {
    return anDataTru(obj, params)
  }
}

export class Gio {
  constructor (gioId) {
    this.gioId = gioId
  }

  anGio (can, chi) {
    return anStructureTru(this, can, chi)
  }

  anDataTru (obj, params) {
    return anDataTru(obj, params)
  }
}

const anStructureTru = (obj, can, chi, ten = null) => {
  obj.khuCan = new KhuCan(can)
  obj.khuChi = new KhuChi(chi)
  obj.thanSat = {
    cattinh: [],
    hungtinh: []
  }
  obj.dungthan = {
    dungthan: {},
    hithan: {},
    kythan: {}
  }
  obj.napam = nguHanhNapAm(chi, can, true)
  obj.nguhanhnapam = nguHanhNapAm(chi, can)

  if (ten) {
    obj.tenTru = ten
    if (obj.truID === 3) {
      obj.khuCan.setNhatChu()
    }
    obj.saoCungMenh = SAO_CUNG_MENH[chi]
  }
  return obj
}

const anCanChi = (obj, params) => {
  const { lenhThang, nhatChuData, lenhThangDong = null } = params
  if (obj.khuCan) {
    // An truong sinh
    const { nguHanhID, amDuong } = obj.khuCan.thienCan
    obj.khuCan.anTruongSinh(tinhTruongSinh(lenhThang, nguHanhID, amDuong))
    if (lenhThangDong) {
      obj.khuCan.anTruongSinhDong(tinhTruongSinh(lenhThangDong, nguHanhID, amDuong))
    }

    // An thap than
    obj.khuCan.anThapThan(tinhThapThan(nguHanhID, nhatChuData.nguHanhID, amDuong * nhatChuData.amDuong))
  }

  if (obj.khuChi) {
    const { canTangChi } = obj.khuChi
    obj.khuChi.anTruongSinhThapThan(canTangChi.map((can) => {
      const { nguHanhID, amDuong } = can
      const truongSinh = tinhTruongSinh(lenhThang, nguHanhID, amDuong)
      let truongSinhDong = null
      if (lenhThangDong) {
        truongSinhDong = tinhTruongSinh(lenhThangDong, nguHanhID, amDuong)
      }
      const thapThan = tinhThapThan(nguHanhID, nhatChuData.nguHanhID, amDuong * nhatChuData.amDuong)
      return {
        ...can,
        truongSinh,
        truongSinhDong,
        thapThan
      }
    }))
  }

  return obj
}

const anDataTru = (obj, params) => {
  // an Can chi
  anCanChi(obj, params)

  // an Than sat
  if (!obj.thanSat) {
    return
  }
  const canID = obj.khuCan?.canID ?? 0
  const chiID = obj.khuChi?.chiID ?? 0
  anThanSat(obj, canID, chiID, params)

  return obj
}

const getParams = (dd, mm, yyyy, gioSinh, minutes, gioiTinh, lenhthang) => {
  let newGioSinh = gioSinh
  let newDd = dd
  if (gioSinh.toString() === '23') {
    newGioSinh = 0
    newDd = dd + 1
  }
  const dataLunar = getDataLunar(mm, yyyy, newDd, newGioSinh, minutes)
  const { alTk } = dataLunar
  const { day, month, hour, year } = alTk

  const [canNgay, chiNgay] = day.name.split(' ')
  const [canGio, chiGio] = hour.name.split(' ')
  const [canThang, chiThang] = month.name.split(' ')
  const [canNam, chiNam] = year.name.split(' ')
  const lenhThang = getDiaChiID(chiThang)
  const lenhThangDong = lenhthang ? getDiaChiID(lenhthang) : null

  const canNamId = getThienCanID(canNam)
  const chiNamId = getDiaChiID(chiNam)
  const canThangId = getThienCanID(canThang)
  const chiThangId = getDiaChiID(chiThang)
  const canNgayId = getThienCanID(canNgay)
  const chiNgayId = getDiaChiID(chiNgay)
  const canGioId = getThienCanID(canGio)
  const chiGioId = getDiaChiID(chiGio)

  const khoiCan = khoiCanNguHoDon(canNamId)

  return { dataLunar, lenhThang, lenhThangDong, khoiCan, gioiTinh, canNgayId, canNamId, chiNamId, canThangId, chiThangId, chiNgayId, canGioId, chiGioId }
}

const tinhThuanNghich = (gioiTinh, tutru) => {
  // tinh am duong nam nu
  let chieuthuan = false
  if ((gioiTinh.toString() === '1' && tutru[1].khuCan.thienCan.amDuong > 0) ||
    (gioiTinh.toString() === '0' && tutru[1].khuCan.thienCan.amDuong < 0)) {
    chieuthuan = true
  }
  return chieuthuan
}

/**
 * Tính số khởi đại vận
 * Sau đó cứ 3 ngày quy đổi là 1 năm,
 * thừa 1 ngày được tính thêm là 4 tháng,
 * thừa 2 ngày được tính thêm là 8 tháng,
 * cứ thừa 1 tiếng được tính thêm là 5 ngày
 * còn cứ thiếu 1 tiếng thì phải trừ đi 5 ngày
 * Cộng tất cả lại sẽ được bao nhiêu năm, tháng, ngày
 * thì đó chính là sau khi sinh được từng đó thời gian
 * sẽ bước vào đại vận đầu tiên
 */
const tinhKhoiDaiVan = (mm, yyyy, dd, gioSinh, minutes, chieuthuan) => {
  const [prevTk, nextTk] = getRangeTietKhi(mm, yyyy, dd, gioSinh, minutes)
  let daysTk, hoursTk
  if (chieuthuan) {
    daysTk = nextTk.days
    hoursTk = nextTk.hours
  } else {
    daysTk = prevTk.days
    hoursTk = prevTk.hours
  }
  // tinh thuong va so du cua ngay
  const thuong = Math.floor(daysTk / 3)
  const sodu = daysTk % 3
  const thuong2 = Math.floor(hoursTk * 5 / 30)
  const sodu2 = hoursTk * 5 % 30
  const khoiDaiVan = { year: thuong, month: sodu * 4 + thuong2, day: sodu2 }

  const ngaySinh = moment(dd + '/' + mm + '/' + yyyy, FORMAT_DATE_TIME)
  const ngayBatDauDaiVan = ngaySinh.add(khoiDaiVan.year, 'years')
    .add(khoiDaiVan.month, 'months').add(khoiDaiVan.day + 1, 'days')

  khoiDaiVan.ngayBatDauDaiVan = ngayBatDauDaiVan.format(FORMAT_DATE_TIME)

  const soKhoiDaiVan = thuong
  let khoiThang = khoiDaiVan.month + mm
  if (khoiThang !== ngayBatDauDaiVan.month() + 1) {
    khoiThang = ngayBatDauDaiVan.month() + 1
  }
  khoiThang = khoiThang <= 1 ? 1 : khoiThang

  return {
    soKhoiDaiVan,
    ngayBatDauDaiVan,
    khoiDaiVan,
    khoiThang
  }
}

const tinhVuongTuongHuuTu = (chiThangId) => {
  let vuongTuongHuuTu = VUONG_TUONG_HUU_TU_THANG[chiThangId]
  vuongTuongHuuTu = {
    ...vuongTuongHuuTu,
    ...diaChi[vuongTuongHuuTu.chiId],
    time: vuongTuongHuuTu.time.map((item) => {
      return {
        ...item,
        ...thienCan[item.canId]
      }
    })
  }
  return vuongTuongHuuTu
}
const setTuTru = (params) => {
  const { khoiCan, canNgayId, canNamId, chiNamId, canThangId, chiThangId, chiNgayId, canGioId, chiGioId } = params
  const tutru = []
  for (var i = 0, j = 7; (i < j); i += 1) {
    tutru.push(new TuTru(i))
  }

  tutru.forEach((tru) => {
    if (tru.truID === 1) {
      tru.anTru('Trụ Năm', canNamId, chiNamId)
    } else if (tru.truID === 2) {
      tru.anTru('Trụ Tháng', canThangId, chiThangId)
    } else if (tru.truID === 3) {
      tru.anTru('Trụ Ngày', canNgayId, chiNgayId)
    } else if (tru.truID === 4) {
      tru.anTru('Trụ Giờ', canGioId, chiGioId)
    } else if (tru.truID === 5) {
      const index = [null, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      let a = 26 - (index[chiThangId] + index[chiGioId])
      if (a > 12) {
        a = a % 12
      }
      if (a === 0) {
        a = 12
      }
      const chiTruId = index.indexOf(a)

      const canTruId = dichCungCan(dichCung(khoiCan, a) - 1, 0)

      tru.anTru('Cung Mệnh', canTruId, chiTruId)
    } else if (tru.truID === 6) {
      const canTruId = dichCungCan(canThangId, 1)
      const chiTruId = dichCung(chiThangId, 3)
      tru.anTru('Thai Nguyên', canTruId, chiTruId)
    }
  })

  return tutru
}

const setDaiVan = (params) => {
  const { soKhoiDaiVan, ngayBatDauDaiVan, chieuthuan, canThangId, chiThangId } = params
  const daivan = []
  for (var dvi = 1, dvj = 11; (dvi < dvj); dvi += 1) {
    daivan.push(new DaiVan(dvi))
  }

  daivan.forEach((dv) => {
    let can = canThangId + dv.daivanId > 10 ? (canThangId + dv.daivanId) % 10 : (canThangId + dv.daivanId)
    let chi = chiThangId + dv.daivanId > 12 ? (chiThangId + dv.daivanId) % 12 : (chiThangId + dv.daivanId)
    if (!chieuthuan) {
      can = canThangId - dv.daivanId > 0 ? canThangId - dv.daivanId : canThangId - dv.daivanId + 10
      chi = chiThangId - dv.daivanId > 0 ? chiThangId - dv.daivanId : chiThangId - dv.daivanId + 12
      can = Math.abs(can % 10)
      chi = Math.abs(chi % 12)
    }
    if (can === 0) can = 10
    if (chi === 0) chi = 12
    dv.anDaivan(can, chi)
    const max = 10 * dv.daivanId + soKhoiDaiVan
    const min = max - 9
    const ngayVaoDaiVan = ngayBatDauDaiVan.add(dv.daivanId === 1 ? 0 : 10, 'years')
    const year = parseInt(ngayVaoDaiVan.format('YYYY'))
    dv.anMinMax(min, max, year, ngayVaoDaiVan.format(FORMAT_DATE_TIME))
    dv.anDataTru(dv, {
      ...params,
      lenhThangDong: dv.khuChi.diaChi.id
    })
  })

  return daivan
}

const setTieuVan = (daivanYear, daivanMin, params) => {
  const { chieuthuan, canGioId, chiGioId } = params
  const tieuvan = []
  for (let lni = 1, lnj = 11; (lni < lnj); lni += 1) {
    const nameTieuVan = daivanYear + lni - 1
    const tuoi = daivanMin + lni - 1
    tieuvan.push(new TieuVan(lni, nameTieuVan, tuoi))
  }
  tieuvan.forEach((tv) => {
    let can = canGioId + tv.tuoi > 10 ? (canGioId + tv.tuoi) % 10 : (canGioId + tv.tuoi)
    let chi = chiGioId + tv.tuoi > 12 ? (chiGioId + tv.tuoi) % 12 : (chiGioId + tv.tuoi)
    if (!chieuthuan) {
      can = canGioId - tv.tuoi > 0 ? canGioId - tv.tuoi : canGioId - tv.tuoi + 10
      chi = chiGioId - tv.tuoi > 0 ? chiGioId - tv.tuoi : chiGioId - tv.tuoi + 12
      can = Math.abs(can % 10)
      chi = Math.abs(chi % 12)
    }
    if (can === 0) can = 10
    if (chi === 0) chi = 12
    tv.anTieuvan(can, chi)
  })
  return tieuvan
}

const setLuuNien = (daivanYear, daivanMin, params) => {
  const luunien = []
  for (let lni = 1, lnj = 11; (lni < lnj); lni += 1) {
    const nameTieuVan = daivanYear + lni - 1
    const tuoi = daivanMin + lni - 1
    luunien.push(new TieuVan(lni, nameTieuVan, tuoi))
  }
  luunien.forEach((ln) => {
    const { can, chi } = getYearLunar(ln.year)
    ln.anTieuvan(can.value + 1, chi.value + 1)
    ln.anDataTru(ln, {
      ...params,
      lenhThangDong: ln.khuChi.diaChi.id
    })
  })
  return luunien
}

const setLuuNienThang = (dvNgayVaoDaiVan, lnTieuVanId, lnCanId, params) => {
  const { khoiThang } = params
  const ngayVaoDaiVan = moment(dvNgayVaoDaiVan, FORMAT_DATE_TIME)
  const luunienThang = []
  for (let lni = 1, lnj = 13; (lni < lnj); lni += 1) {
    luunienThang.push(new Thang(lni))
  }

  let ngayVaoLuunienNam = moment(ngayVaoDaiVan)
  ngayVaoLuunienNam = ngayVaoLuunienNam.add(lnTieuVanId, 'year')

  luunienThang.forEach((lnt, indexLn) => {
    const khoiCanThang = khoiCanNguHoDon(lnCanId)
    const chiSoDichThang = khoiThang + indexLn - 1
    const can = dichCungCan(khoiCanThang, chiSoDichThang > 10 ? dichCung(0, chiSoDichThang) : chiSoDichThang)
    const chi = dichCung(3, chiSoDichThang)

    let ngayVaoLuunienThang = moment(ngayVaoLuunienNam)
    ngayVaoLuunienThang = ngayVaoLuunienThang.add(lnt.thangId - 1, 'months')
    const dayOfMonth = ngayVaoLuunienThang.daysInMonth()

    lnt.anDayOfMonth(dayOfMonth)
    lnt.anNgayVaoLuunienThang(ngayVaoLuunienThang)
    lnt.anThang(can, chi)
    lnt.anDataTru(lnt, params)
  })
  return luunienThang
}

const setLuuNienNgay = (luunienThang, params) => {
  const luunienNgay = []
  const dayOfMonth = luunienThang.dayOfMonth
  const ngayVaoLuunienThang = luunienThang.ngayVaoLuunienThang
  for (let lni = 1, lnj = dayOfMonth + 2; (lni < lnj); lni += 1) {
    let ngayVaoLuunienNgay = moment(ngayVaoLuunienThang)
    ngayVaoLuunienNgay = ngayVaoLuunienNgay.add(lni - 1, 'days')

    luunienNgay.push(new Ngay(lni, ngayVaoLuunienNgay.format(FORMAT_DATE_TIME)))
  }

  luunienNgay.forEach((lnn) => {
    const [lnnDay, lnnMonth, lnnYear] = lnn.ngayVaoLuunienNgay.split('/')
    const lnnLunar = getDataLunar(parseInt(lnnMonth), parseInt(lnnYear), parseInt(lnnDay))

    const dayCanChi = lnnLunar.al.day.name
    const [canStr, chiStr] = dayCanChi.split(' ')
    const canID = getThienCanID(canStr)
    const chiID = getDiaChiID(chiStr)

    lnn.anNgay(canID, chiID)
    lnn.anDataTru(lnn, params)
  })
  return luunienNgay
}

const setLuuNienGio = (lnnCanId, params) => {
  const luunienGio = []
  for (let lni = 1, lnj = 13; (lni < lnj); lni += 1) {
    luunienGio.push(new Gio(lni))
  }

  luunienGio.forEach((lng, index) => {
    const khoiCanThang = khoiCanGio(lnnCanId)
    const can = dichCungCan(khoiCanThang, index)
    const chi = dichCung(1, index)

    lng.anGio(can, chi)
    lng.anDataTru(lng, params)
  })
  return luunienGio
}

// eslint-disable-next-line no-unused-vars
const setDv = (canA, canB, index = [-1, -1], khoangcach = 1) => {
  const indexA = index[0] ?? -1
  const indexB = index[1] ?? -1
  let newCanA = { ...canA }
  let newCanB = { ...canB }
  if (indexA >= 0) {
    const canTangChi = canA.canTangChi[indexA]
    if (!canTangChi) {
      return
    }
    newCanA = { dovuong: canA.canTangChi[indexA].dovuong, thienCan: canA.canTangChi[indexA] }
  }
  if (indexB >= 0) {
    const canTangChi = canB.canTangChi[indexB]
    if (!canTangChi) {
      return
    }
    newCanB = { dovuong: canB.canTangChi[indexB].dovuong, thienCan: canB.canTangChi[indexB] }
  }
  const [newA, newB] = tinhDoVuongTheoKhoangCach(newCanA, newCanB, khoangcach)
  canA.anDoVuong(newA, indexA)
  canB.anDoVuong(newB, indexB)
}

const setDoVuongTuTru = (tutru) => {
  // console.log(tutru)
  // tinh do vuong theo khoang cach
  const khuCanNam = tutru[1].khuCan
  const khuCanThang = tutru[2].khuCan
  const khuCanNgay = tutru[3].khuCan
  const khuCanGio = tutru[4].khuCan
  const khuChiNam = tutru[1].khuChi
  const khuChiThang = tutru[2].khuChi
  const khuChiNgay = tutru[3].khuChi
  const khuChiGio = tutru[4].khuChi

  const arrayData = [
    [[khuCanNam, -1], [khuCanThang, -1], [khuCanNgay, -1], [khuCanGio, -1]],
    [[khuChiNam, 0], [khuChiThang, 0], [khuChiNgay, 0], [khuChiGio, 0]],
    [[khuChiNam, 1], [khuChiThang, 1], [khuChiNgay, 1], [khuChiGio, 1]],
    [[khuChiNam, 2], [khuChiThang, 2], [khuChiNgay, 2], [khuChiGio, 2]]
  ]

  const array = [
    [1, 2, 3, 4],
    [5, 6, 7, 8],
    [9, 10, 11, 12],
    [13, 14, 15, 16]
  ]

  _loopDv(array, arrayData, 4)
}

const _setDv = (array, arrayData, i, j, iVal, jVal) => {
  if (array[i][j] && array[i + iVal] && array[i + iVal][j + jVal]) {
    const [itemA, indexA] = arrayData[i][j]
    const [itemB, indexB] = arrayData[i + iVal][j + jVal]
    const khoangcach = (iVal * iVal) + (jVal * jVal)
    // console.log(iVal, jVal, array[i][j], array[i + iVal][j + jVal], khoangcach)
    setDv(itemA, itemB, [indexA, indexB], khoangcach)
  }
}

const _loopDv = (array, arrayData, n) => {
  const arr = [...Array(n).keys()]
  // const arr = [
  //   [0, 1], [1, 0],
  //   [0, 2], [2, 0],
  //   [0, 3], [3, 0],
  //   [1, 1], [1, -1],
  //   [1, 2], [2, 1], [1, -2], [2, -1],
  //   [2, 2], [2, -2],
  //   [1, 3], [3, 1], [1, -3], [3, -1],
  //   [2, 3], [3, 2], [2, -3], [3, -2],
  //   [3, 3], [3, -3]
  // ]

  for (let i = 0; i < n; i++) {
    for (let j = 0; j < n; j++) {
      for (let i2 = 0; i2 < n; i2++) {
        for (let j2 = 0; j2 < n; j2++) {
          const iVal = arr[i2]
          const jVal = arr[j2]
          if (iVal || jVal) {
            _setDv(array, arrayData, i, j, iVal, jVal)
            if (iVal && jVal) {
              _setDv(array, arrayData, i, j, iVal, 0 - arr[j2])
            }
          }
        }
      }
    }
  }
}

export const lapTuTru = (dd, mm, yyyy, gioSinh, minutes, gioiTinh, lenhthang, isGenNgay) => {
  let params = getParams(dd, mm, yyyy, gioSinh, minutes, gioiTinh, lenhthang)
  const { dataLunar, chiThangId } = params

  const curYear = new Date().getFullYear()

  const tutru = setTuTru(params)
  const nhatChuData = tutru[3].khuCan.thienCan

  // tinh am duong nam nu
  const chieuthuan = tinhThuanNghich(gioiTinh, tutru)
  const dataKhoiDaiVan = tinhKhoiDaiVan(mm, yyyy, dd, gioSinh, minutes, chieuthuan)
  const { khoiDaiVan } = dataKhoiDaiVan

  params = {
    ...params,
    nhatChuData,
    chieuthuan,
    ...dataKhoiDaiVan
  }

  tutru.forEach((tru) => {
    tru.anDataTru(tru, params)
  })

  setDoVuongTuTru(tutru)

  let curYearOld
  const daivan = setDaiVan(params)
  daivan.forEach((dv) => {
    const luunien = setLuuNien(dv.year, dv.min, params)
    const tieuvan = setTieuVan(dv.year, dv.min, params)
    tieuvan.forEach((tv, indexTv) => {
      if (tv.year.toString() === curYear.toString()) {
        curYearOld = tv.tuoi
      }
      tv.anDataTru(tv, {
        ...params,
        lenhThangDong: luunien[indexTv].khuChi.diaChi.id
      })
    })
    dv.tieuvan = tieuvan

    luunien.forEach((ln) => {
      const lenhThangLn = ln.khuChi.diaChi.id
      const newParams = {
        ...params,
        lenhThangDong: lenhThangLn
      }
      const luunienThang = setLuuNienThang(dv.ngayVaoDaiVan, ln.tieuVanId - 1, ln.khuCan?.canID ?? 0, newParams)
      luunienThang.forEach((lnt) => {
        if (isGenNgay) {
          lnt.luunienNgay = getLuunienNgay(lnt, newParams)
        }
      })
      ln.luunienThang = luunienThang
    })
    dv.luunien = luunien
  })

  const laso = {
    khoiDaiVan,
    dataLunar,
    curYearOld,
    tutru,
    daivan,
    vuongTuongHuuTu: tinhVuongTuongHuuTu(chiThangId),
    params
  }
  // console.log(tutru)

  return laso
}

export const getLuunienNgay = (luunienThang, params) => {
  const luunienNgay = setLuuNienNgay(luunienThang, params)
  luunienNgay.forEach((lnn) => {
    lnn.luunienGio = setLuuNienGio(lnn?.khuCan?.canID ?? 0, params)
  })
  // luunienNgay.pop()

  return luunienNgay
}

export const getDataChart = (dd, mm, yyyy, gioSinh, minutes, gioiTinh) => {
  const { tutru, daivan } = lapTuTru(dd, mm, yyyy, gioSinh, minutes, gioiTinh, null, true)

  let dvObjTuTru = {}
  const dvByDay = []
  tutru.forEach((tru, index) => {
    if (index > 0) {
      dvObjTuTru = tinhDvTheoThapThan(dvObjTuTru, tru)
    }
  })

  daivan.forEach((dv) => {
    let dvObjDaiVan = {}
    dvObjDaiVan = tinhDvTheoThapThan(dvObjTuTru, dv)
    dv.luunien.forEach((ln, idx) => {
      let dvObjLn = {}
      dvObjLn = tinhDvTheoThapThan(dvObjDaiVan, dv.tieuvan[idx])
      dvObjLn = tinhDvTheoThapThan(dvObjDaiVan, ln)
      ln.luunienThang.forEach((lnt) => {
        let dvObjLnt = {}
        dvObjLnt = tinhDvTheoThapThan(dvObjLn, lnt)
        lnt.luunienNgay.forEach((lnn) => {
          const day = moment(lnn.ngayVaoLuunienNgay, FORMAT_DATE_TIME).unix()
          const data = tinhDvTheoThapThan(dvObjLnt, lnn)
          dvByDay.push({
            ...data,
            time: day * 1000
          })
        })
      })
    })
  })

  const dvKey = [...THAP_THAN]

  const dvByThapThan = {}
  dvByDay.forEach((item, idx) => {
    dvKey.forEach((key) => {
      if (!dvByThapThan[key]) {
        dvByThapThan[key] = {}
        dvByThapThan[key].name = key
        dvByThapThan[key].data = []
      }
      dvByThapThan[key].data.push([item.time, parseInt(item[key])])
    })
  })

  return Object.values(dvByThapThan)
}

export const getThienCanID = (tenCan) => {
  return THIEN_CAN.findIndex((can) => can === tenCan)
}

export const getDiaChiID = (tenChi) => {
  if (tenChi === 'Tỵ') {
    tenChi = 'Tị'
  }
  return DIA_CHI.findIndex((chi) => chi === tenChi)
}

export const getRoundDecimal = (value) => {
  return Math.round(value * 10) / 10
}
